import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';

// Pages
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import GaresAeroportsPage from './pages/GaresAeroportsPage';
import TransportPMRPage from './pages/TransportPMRPage';
import EvenementsPage from './pages/EvenementsPage';
import VehiculesPage from './pages/VehiculesPage';
import DispatchPatronPage from './pages/DispatchPatronPage';
import MentionsLegalesPage from './pages/MentionsLegalesPage';
import CGVPage from './pages/CGVPage';

function App() {
  return (
    <Router>
      <div className="App min-h-screen flex flex-col bg-gray-900">
        <Navbar />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/qui-sommes-nous" element={<AboutPage />} />
            <Route path="/gares-aeroports" element={<GaresAeroportsPage />} />
            <Route path="/transport-pmr" element={<TransportPMRPage />} />
            <Route path="/evenements" element={<EvenementsPage />} />
            <Route path="/vehicules" element={<VehiculesPage />} />
            <Route path="/dispatch-patron" element={<DispatchPatronPage />} />
            <Route path="/mentions-legales" element={<MentionsLegalesPage />} />
            <Route path="/cgv-rgpd" element={<CGVPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
